import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Draggable } from "react-drag-reorder";
import {
  updateDepartmentResourcePriority,
  getDepartmentResources,
} from "../../../../action/masters/departmentResourceActionCreator";
import {
  changePositionOnDrag,
  prioratiseItems,
} from "../../../../common-functions/commonFunctions";
import { cloneDeep, baseURL } from "../../../../constants/commonConstants";
import { getAlertData } from "../../../../helper/sweet-alert";
import {
  IUpdateDepartmentResourcePriority,
  IDepartmentResources,
} from "../../../../models/master/departmentResources";
import { setDepartmentResources } from "../../../../store/slices/master/departmentResource";
import LoaderSpinner from "../../../../common-components/loader";
import { ConfigUserTypes } from "../../../../models/dashboard/adminDashboard";

const PriorityDepartmentResources = (
  props: IUpdateDepartmentResourcePriority
) => {
  const {
    updateDepartmentResourcePriority,
    getDepartmentResources,
    departmentResources,
    configUserRole,
  } = props;
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const dispatch = useDispatch();
  const saveChangedPos = async (currentPos: any, newPos: any) => {
    if (currentPos != newPos) {
      setLoader(true);
      let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
      await setfilteredItems(_items);
      updateDepartmentResourcePriority(_items, setAlert);
    }
  };

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    /////method 1
    setLoader(true);
    
    let index = filteredItems.findIndex((x) => x.id == id);
    let _afterFilteration = [];
    let _filteredItems = [...filteredItems];
    let selectedItem = _filteredItems.splice(index, 1);
    selectedItem[0].displayOrNot = _displayOrNot;

    selectedItem[0].priority = null;
    _afterFilteration = [
      ...prioratiseItems(_filteredItems.filter((x) => x.displayOrNot == true)),
      ...selectedItem,
      ..._filteredItems.filter((x) => x.displayOrNot == false),
    ];
    let _items = prioratiseItems(_afterFilteration);
    
    setfilteredItems([..._items]);
    updateDepartmentResourcePriority(_items, setAlert);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setLoader(false);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllDepartmentResources = async (pageBlockId?: number, 
    noOfItems?: number, 
    configUserType?: number) => {
    setLoader(true)
    try {
      await getDepartmentResources(pageBlockId, noOfItems, configUserType);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getAllDepartmentResources(undefined, undefined, ConfigUserTypes.Staff);
    return () => {
      dispatch(setDepartmentResources([]));
    };
  }, [configUserRole]);

  useEffect(() => {
    departmentResources && setfilteredItems(cloneDeep(departmentResources));
  }, [departmentResources]);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Department Resources</h2>
        </div>
  
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {loader ? (
            <LoaderSpinner />
          ) : filteredItems && filteredItems?.length > 0 ? (
            <>
              <Draggable
                onPosChange={async (currentPos, newPos) => {
                  await saveChangedPos(currentPos, newPos);
                }}
              >
                {filteredItems
                  .filter((item: IDepartmentResources) => item.displayOrNot)
                  .map(
                    (departmentResource: IDepartmentResources, index: number) => (
                      <li className="admin-card">
                        <div className="top">
                          <span className="handle">
                            <img src="/assets/images/drag.svg" />
                          </span>
                          <span className="counter">
                            {departmentResource.priority}
                          </span>
                          <div className="form-checkbox">
                            <input
                              type="checkbox"
                              checked={departmentResource.displayOrNot}
                              id={departmentResource.priority + "app"}
                              onChange={() => {
                                ChangeVisibleOrNot(
                                  departmentResource.id ?? 0,
                                  !departmentResource.displayOrNot
                                );
                              }}
                            />
                            <label
                              htmlFor={departmentResource.priority + "app"}
                            ></label>
                          </div>
                        </div>
                        <div className="btm">
                          <div className="img">
                            <img
                              src={
                                departmentResource.image
                                  ? baseURL + departmentResource.image
                                  : ""
                              }
                              alt=""
                            />
                          </div>
                          <h2>{departmentResource.name}</h2>
                        </div>
                      </li>
                    )
                  )}
              </Draggable>
              {filteredItems
                .filter((item: IDepartmentResources) => !item.displayOrNot)
                .map(
                  (departmentResource: IDepartmentResources, index: number) => (
                    <li className="admin-card">
                      <div className="top">
                        <span className="handle">
                          <img src="/assets/images/drag.svg" />
                        </span>
                        <span className="counter">
                          {}
                        </span>
                        <div className="form-checkbox">
                          <input
                            type="checkbox"
                            checked={departmentResource.displayOrNot}
                            id={departmentResource.priority + ""}
                            onChange={() => {
                              
                              ChangeVisibleOrNot(
                                departmentResource.id ?? 0,
                                !departmentResource.displayOrNot
                              );
                            }}
                          />
                          <label
                            htmlFor={departmentResource.priority + ""}
                          ></label>
                        </div>
                      </div>
                      <div className="btm">
                        <div className="img">
                          <img
                            src={
                              departmentResource.image
                                ? baseURL + departmentResource.image
                                : ""
                            }
                            alt=""
                          />
                        </div>
                        <h2>{departmentResource.name}</h2>
                      </div>
                    </li>
                  )
                )}
            </>
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  updateDepartmentResourcePriority: (data: any, callBack: Function) =>
    updateDepartmentResourcePriority(data, callBack),
  getDepartmentResources: (pageBlockId?: number, noOfItems?: number, configUserType?: number) =>
    getDepartmentResources(pageBlockId, noOfItems, configUserType),
};

function mapStateToProps(state: any) {
  return {
    departmentResources: state.departmentResource.departmentResources,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PriorityDepartmentResources);
